module.exports = __webpack_public_path__ + "img/138.6.2c5e1874.png";